import { render, staticRenderFns } from "./ModalResonTour.vue?vue&type=template&id=3f9e771c"
import script from "./ModalResonTour.vue?vue&type=script&lang=js"
export * from "./ModalResonTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports